import React, { Component } from "react";
import { broadcastAnd, logout, changeUser } from "../redux/actions";
import { connect } from "react-redux";
import SmarterReactPlayer from "./SmarterReactPlayer";
import { AblyReceiver } from "./AblyReceiver";
import { ChatBox } from "./ChatBox";
import { ReadyModal } from "./ReadyModal";
import Sidebar from "./Sidebar";
import { isMobile } from "react-device-detect";
import VideoPositionCalculator from "./VideoPositionCalculator";
import { StayAwake } from "./StayAwake";


export class UnconnectedPageRoom extends Component {

	constructor(props) {
		super(props);
		this.state = { modal_needed: true }; //need to force user interaction so we can play video
	}

	componentDidMount() {
		this.setInitialViewMode();
	}

	setInitialViewMode() {
		this.props.changeUser("view_mode", isMobile ? "chat" : "full");
	}


	/* Can't render page under the modal because we don't want to try to make the video player play (which we'll only do once) until they've clicked */
	renderModalOrPage() {
		return (this.state.modal_needed ? <ReadyModal onClick={this.modalClick.bind(this)} /> : this.renderPage());
	}

	renderVideo() {
		return (
			<div style={{ flex: "4 0 0" }}>
				<SmarterReactPlayer />
			</div>
		);
	}

	renderChat() {
		return (
			<div style={{ flex: "1 0 0", overflow: "hidden" }}>
				<Sidebar>
					<ChatBox />
				</Sidebar>
			</div>
		);
	}

	/* Normally SmarterReactPlayer will render controls, but in the view mode where it's not present, ChatBox will */
	renderContents() {
		switch(this.props.view_mode) {
			case "full":
				return (<>{this.renderVideo()}{this.renderChat()}</>);
			case "video":
				return this.renderVideo();
			case "chat":
				return (<>{this.renderChat()}<StayAwake/></>);
			default:
		}
	}

	renderPage() {
		return (
			<div style={{ height: "100%", display: "flex", flexDirection: "row" }}>
				{ this.renderContents() }
			</div>
		);
	}

	modalClick() {
		this.setState({ modal_needed: false });
	}

	render() {

		return (
			<>
				<AblyReceiver />
				{this.renderModalOrPage()}
				<VideoPositionCalculator />
			</>
		);
	}
}

const mapStateToProps = state => ({ room_key: state.user.room_key, nick_name: state.user.nick_name, view_mode: state.user.view_mode });
export const PageRoom = connect(mapStateToProps,  { broadcastAnd, logout, changeUser })(UnconnectedPageRoom);
